// extracted by mini-css-extract-plugin
export default {"form":"AddCustomerModal_form__+0rQQ","input":"AddCustomerModal_input__JtjH4"};